module.exports = __webpack_public_path__ + "img/Phone_DSD.a953d58a.png";